import React, { useState } from 'react';

import s from "./Layout.module.css"
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useIsMobile } from '../../hooks/mobileHook';
import { useLocation } from 'react-router-dom';

export function Layout({ children }) {
    const isMobile = useIsMobile();

    const [activeSideBar, setActiveSideBar] = useState(true)
    const [activeMenuItem, setActiveMenuItem] = useState('')

    const location = useLocation();

    const isSettingsPage = location.pathname === '/settings';

    return (
        <>
            <Header />
            <div className={s.main}>
                {!isMobile ? (
                    <>
                        {activeSideBar ? (
                            isSettingsPage ? (
                                <></>
                            ) : (
                                <Sidebar setActiveSideBar={setActiveSideBar} setActiveMenuItem={setActiveMenuItem} />
                            )
                        ) : (
                            <div onClick={() => setActiveSideBar(true)} className={s.showSidebarButton}>
                                <img src={'/showlogo.svg'}></img>
                            </div>

                        )}
                    </>
                ) : (
                    <></>
                )
                }
                {children}
            </div>
        </>
    )
}